import { IconProps } from "./types";

export const CheckBoxUnfilled = ({ fill = "white" }: IconProps) => {
  return (
    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7305_102269)">
        <rect x="0.5" width="34" height="34" rx="4" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_7305_102269">
          <rect width="34" height="34" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
